import api from "./httpClient";

/**
 * GET /api/InformationHistory/ListByInformationId/{informationId}
 *
 * @param {number|string} informationId
 * @param {AbortSignal} [signal]
 */
export function getInformationHistoryByInformationId(informationId, signal) {
  return api.get(`/InformationHistory/ListByInformationId/${informationId}`, {
    signal,
    headers: { "Content-Type": "application/json" },
  });
}
